import React, { useState } from "react";
import "../../Css/LoginBusiness.css";
import iconFacebook from "../../IMG/Icon/facebook.png";
import iconInsta from "../../IMG/Icon/instagram.png";
import iconWhatsapp from "../../IMG/Icon/whatsapp.png";
import iconLinkdin from "../../IMG/Icon/linkedin.svg";
import { Link, useNavigate } from "react-router-dom";
import {useBusinessAuth} from "../../Middleware/context/BusinessContext";

function LoginBusiness() {
  const navigate = useNavigate();
  const [dadosCompany, setDadosCompany] = useState({ email: "", password: "" });
const { login } = useBusinessAuth();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDadosCompany((prev) => ({ ...prev, [name]: value }));
  };



const handleLogin = async () => {
  await login(dadosCompany?.email, dadosCompany?.password);
  navigate("/Home");
};

  const handleNewBusiness = () => {
    navigate("/Register");
  };

  return (
    <div className="divmain">
      <div className="cont">
        <div className="form sign-in">
          <div id="form_sign">
            <h2 className="h2main">Sign In</h2>

            <label className="lblmain">
              <span className="spanMain">Identificação</span>
              <input
                type="text"
                className="inpMain"
                id="idText"
                name="email"
                value={dadosCompany.email}
                onChange={handleChange}
                required
              />
            </label>

            <label className="lblmain">
              <span className="spanMain">Password</span>
              <input
                type="password"
                className="inpMain"
                id="psswText"
                name="password"
                value={dadosCompany.password}
                onChange={handleChange}
                required
              />
            </label>

            <button className="submit" id="submit" onClick={handleLogin}>
              Sign In
            </button>
          </div>

          <p onClick={handleNewBusiness} className="forgot-pass pmain">
            CREATE YOUR COMPANY ON TOU AKI ?
          </p>

          <div className="social-media">
            <ul>
              <Link to={"https://www.facebook.com/Tou.Aki.E.Commerce"}>
              <li>
                <img src={iconFacebook} alt="Facebook" />
              </li>
               </Link>
               <Link to={"https://www.whatsapp.com/catalog/244991660829"}> 
              <li>
                <img src={iconWhatsapp} alt="Whatsapp" />
              </li>
              </Link>
              <li>
                <img src={iconInsta} alt="Instagram" />
              </li>
              <li>
                <img src={iconLinkdin} alt="LinkedIn" />
              </li>
            </ul>
          </div>
        </div>

        <div className="sub-cont">
          <form method="get" id="form-cads">
            <div className="img">
              <div className="img-text m-up">
                <a id="logomarca" href="/">
                  <h2 className="h2main">Tou Aki Business</h2>
                </a>
                <p className="pmain">
                  Sign up and discover great amount of new opportunities!
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginBusiness;